var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Accordion, AccordionDetails, AccordionSummary, Switch, Typography, } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { isBoolean } from '../../../utils';
import { useIsSmallScreen } from '../../../hooks';
import ArrowIcon from './ArrowIcon';
import CategoryTitle from './CategoryTitle';
const Description = styled(Typography).attrs(() => ({
    variant: 'body2',
    color: 'textSecondary',
})) `
  ${({ theme }) => `
    ${theme.breakpoints.down('sm')} {
      margin-bottom: 24px;
    }
  `}
`;
const useStyles = makeStyles({
    content: {
        display: 'flex',
        alignItems: 'center',
    },
});
const StyledAccordionDetails = styled(AccordionDetails) `
  display: flex;
  flex-direction: column;
`;
const Category = (_a) => {
    var { children, checked, description, onChange, title } = _a, rest = __rest(_a, ["children", "checked", "description", "onChange", "title"]);
    const classes = useStyles();
    const isSmallScreen = useIsSmallScreen();
    const [expanded, setExpanded] = useState(false);
    const [isChecked, setIsChecked] = useState(false);
    const stopPropagation = (event) => {
        event.stopPropagation();
    };
    const onToggle = (event) => {
        stopPropagation(event);
        onChange && onChange(event);
        if (!isBoolean(checked)) {
            setIsChecked((isChecked) => !isChecked);
        }
    };
    return (React.createElement(Accordion, Object.assign({ expanded: expanded, onChange: () => setExpanded((prev) => !prev) }, rest),
        React.createElement(AccordionSummary, { expandIcon: React.createElement(ArrowIcon, null), classes: { content: classes.content } },
            React.createElement(Switch, { checked: isBoolean(checked) ? checked : isChecked, onChange: onToggle, onClick: stopPropagation, onFocus: stopPropagation, color: "primary" }),
            React.createElement(CategoryTitle, null, title),
            description && !isSmallScreen && React.createElement(Description, null, description)),
        React.createElement(StyledAccordionDetails, null,
            isSmallScreen && React.createElement(Description, null, description),
            children)));
};
Category.displayName = 'CookiesConsent.Category';
Category.propTypes = {
    checked: PropTypes.bool,
    children: PropTypes.node,
    description: PropTypes.string,
    onChange: PropTypes.func,
    title: PropTypes.string.isRequired,
};
const CategoryExtra = styled(Category) ``;
export default CategoryExtra;
